<div class="card" [routerLink]="card?.link" [ngClass]="{ 'card--disabled': disabled }" (click)="emitClick.emit()" #cardDOM>
  <div class="card__title" [ngClass]="{ hidden: empty }">
    <h4 class="h4">
      {{ card?.title | translate: { value: card?.icon } }}
      <span *ngIf="card?.dynamicTitle">{{ card?.dynamicTitle.toString() }}</span>
    </h4>
    <div class="flex items-center pt-2">
      <span class="subtitle pr-4">{{ card?.subtitle | translate }}</span>
      <svg-icon key="chevron-right" [ngClass]="{ 'card__icon--disabled': disabled }"></svg-icon>
    </div>
  </div>
  <ng-content></ng-content>
</div>
